<f-flow
    fDraggable
    (fCreateConnection)="onCreateConnection($event)"
    (fReassignConnection)="connectionReassigned.emit($event)">
    <f-canvas fZoom>
        <f-connection-for-create fBehavior="floating"></f-connection-for-create>
        <f-connection *ngFor="let c of connections$|async" [fOutputId]="c.from" [fInputId]="c.to" [fReassignDisabled]="false"></f-connection>
        <div *ngFor="let node of deviceNodes" fNode [fNodePosition]="node.position" fDragHandle (fNodePositionChange)="onNodeChanged(node.id, $event)" class="node-content">
            <div fNodeInput [fInputId]="node.inputId" class="flex center middle">
                <mat-icon>fiber_manual_record</mat-icon>
            </div>
            <device-node
                [node]="node"
                [hasUpstreamConnection]="reductionRatioState.connectedDownstreamDeviceIds.has(node.device.id)"
                [reductionRatioLoading]="reductionRatioState.loading"
                [reductionRatio]="reductionRatioState.ratiosByDownstreamDeviceId.get(node.device.id)">
            </device-node>
            <div fNodeOutput [fOutputId]="node.outputId" class="draggable" [fOutputMultiple]="true">
                <mat-icon>fiber_manual_record</mat-icon>
            </div>
        </div>
        <div *ngFor="let node of psdChartNodes" fNode [fNodePosition]="node.position" fDragHandle class="node-content">
            <chart-node [node]="node"></chart-node>
        </div>
    </f-canvas>
</f-flow>
